import React from 'react';

import type { FeatureFlag } from 'src/shared/constants';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { LinkoutCard } from '../../Card';

import {
  HeaderSection,
  ProjectCardSection,
  ProjectCardWrapper,
} from './ProjectCardSection';

const ExploreServices = ({
  projectId,
  config,
}: {
  projectId: string;
  config: Partial<FeatureFlag.ProjectLinkouts>;
}) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  if (!config?.exploreServices) return null;

  // TODO: Update these to be consistent with the design system colors with DSYS-538
  const backgroundColors = ['#425045', '#3F5976'];

  const servicesWithColor = config.exploreServices.map(
    ({ ...attr }, index) => ({
      ...attr,
      backgroundColor: backgroundColors[index] || backgroundColors[0],
      key: attr.title,
    }),
  );

  return (
    <>
      <HeaderSection
        subtitle={t('projects.exploreServices.subtitle')}
        title={t('projects.exploreServices.title')}
      />

      <ProjectCardSection>
        {servicesWithColor.map(service => (
          <ProjectCardWrapper key={service.key}>
            <LinkoutCard
              optionalTrackingProperties={{
                track_id: 'services-link-out',
                link_location: 'Services Tile',
                project_id: Number(projectId),
              }}
              {...service}
            />
          </ProjectCardWrapper>
        ))}
      </ProjectCardSection>
    </>
  );
};

export { ExploreServices };
